import { render } from "./PasswordStrengthIndicator.vue?vue&type=template&id=0c40c05d&scoped=true"
import script from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js"
export * from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js"

import "./PasswordStrengthIndicator.vue?vue&type=style&index=0&id=0c40c05d&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c40c05d"]])

export default __exports__